import { assertNever, assertNotOptional } from '@wix/seo-common-core';
import { ComponentType, getComponentStyleSource } from '../../common';
import { updateDesignBgColor } from './helpers/update-design-bg-color';
import { updateStylePropertiesObject } from './helpers/update-style-properties-object';
export function updateComponentStyle(component, properties) {
  const {
    id,
    type
  } = component;
  const styleSource = getComponentStyleSource(type);
  if (styleSource === 'STYLE') {
    const {
      style
    } = component;
    assertNotOptional(style, 'style');
    return updateStylePropertiesObject(component, properties);
  }
  if (styleSource === 'DESIGN') {
    const {
      design
    } = component;
    assertNotOptional(design, 'design');
    if (!properties.bgColor) {
      throw new Error('Background color is required for design components');
    }
    return updateDesignBgColor(component, properties.bgColor);
  }
  if (styleSource === 'CUSTOM') {
    if (type === ComponentType.Text) {
      return updateStylePropertiesObject(component, properties);
    }
    throw new Error(`Missing custom updater for component type - ${type}`);
  }
  if (styleSource === 'UNKNOWN') {
    throw new Error(`Component ${id} with type ${type} is not supported`);
  }
  assertNever(styleSource);
}
//# sourceMappingURL=update-component-style.js.map